import React from "react";
import ReactDOM from "react-dom/client";
import App from './App';
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


// Defer PostHog initialization to reduce main thread blocking
if (process.env.REACT_APP_PUBLIC_POSTHOG_KEY) {
  setTimeout(() => {
    import('posthog-js').then((posthogModule) => {
      const posthog = posthogModule.default;
      posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
        api_host: 'https://eu.posthog.com',  // EU endpoint
        persistence: 'localStorage',
        debug: false,
        disable_session_recording: true,
        console_log_level: 'error',
        disable_feature_flags: true,
        autocapture: false,
        bootstrap: {
          distinctId: localStorage.getItem('posthog_distinct_id') || `${Date.now()}-${Math.random().toString(36).substring(2)}`
        },
        loaded: (posthog) => {
          // Make posthog available globally for other components
          window.posthog = posthog;
        }
      });
    });
  }, 1);
}
